import FinalCTA from "../../components/layout/FinalCTA";
import OurWorkingAreas from "../../components/layout/OurWorkingAreas";
import AboutHero from "./AboutHero";
import Leadership from "./Leadership";
import OurCoverage from "./OurCoverage";
import VisionMission from "./VisionMission";
import WhoWeAre from "./WhoWeAre";
import PageSEO from './../../components/PageSEO';
import CEOSection from "../../components/layout/CEOSection";

export default function About() {
  return (
    <>
      <PageSEO
        title="About Vision X Nexus | Luxury Real Estate Consultants in Dubai & Sharjah"
        description="Vision X Nexus Real Estate L.L.C is a luxury real estate consultancy providing expert advisory services across Dubai, Sharjah, and Ajman. Built on trust, market expertise, and integrity."
        canonical="https://visionxnexus.com/about"
        pageName="About Vision X Nexus"
        faqs={[
          {
            question: "Who is Vision X Nexus?",
            answer:
              "Vision X Nexus is a UAE-based luxury real estate consultancy offering residential, commercial, and investment advisory services.",
          },
          {
            question: "Which cities does Vision X Nexus operate in?",
            answer:
              "We operate across Dubai, Sharjah, and Ajman, focusing on high-growth residential and commercial areas.",
          },
        ]}
      />
      <AboutHero />
      <WhoWeAre />
      <VisionMission />
      <OurWorkingAreas />
      {/* <CEOSection /> */}
      {/* <Leadership /> */}
      <OurCoverage />
      <FinalCTA />
    </>
  );
}
